var DepartmentModule = (function () {
    function DepartmentModule() {
    }
    return DepartmentModule;
}());
export { DepartmentModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/department/department.module.ts.pre-build-optimizer.js